export default "__VITE_ASSET__bc949455__"